import { SxProps } from '@mui/joy/styles/types';

import { theme } from 'theme';

export const inputStyle: SxProps = {
  textTransform: 'uppercase',

  '::placeholder': {
    textTransform: 'none',
  },
};

export const autocompleteStyle: SxProps = {
  width: 300,
};

export const listboxStyle: SxProps = {
  width: '400px !important',
  maxHeight: '80vh !important',
};

export const endDecoratorStyle: SxProps = {
  cursor: 'pointer',
};

export const descriptionStyle: SxProps = {
  color: theme.palette.neutral[800],
};
